import { render, staticRenderFns } from "./CaduceoLapManagementMediciList.vue?vue&type=template&id=7a6758a4"
import script from "./CaduceoLapManagementMediciList.vue?vue&type=script&lang=js"
export * from "./CaduceoLapManagementMediciList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports